// Copyright © 2021 The Things Industries B.V.

// This list needs to stay in sync with the AWS regions where the AWS IoT integration has been deployed to.
// See https://github.com/TheThingsIndustries/lorawan-stack-aws-integration/blob/master/.github/workflows/release.yaml
export default Object.freeze({
  'af-south-1': 'Africa, Cape Town',
  'ap-east-1': 'Asia Pacific, Hong Kong',
  'ap-northeast-1': 'Asia Pacific, Tokyo',
  'ap-northeast-2': 'Asia Pacific, Seoul',
  'ap-south-1': 'Asia Pacific, Mumbai',
  'ap-southeast-1': 'Asia Pacific, Singapore',
  'ap-southeast-2': 'Asia Pacific, Sydney',
  'ca-central-1': 'Canada, Central',
  'eu-central-1': 'Europe, Frankfurt',
  'eu-north-1': 'Europe, Stockholm',
  'eu-south-1': 'Europe, Milan',
  'eu-west-1': 'Europe, Ireland',
  'eu-west-2': 'Europe, London',
  'eu-west-3': 'Europe, Paris',
  'me-south-1': 'Middle East, Bahrein',
  'sa-east-1': 'South America, São Paulo',
  'us-east-1': 'United States, North Virginia',
  'us-east-2': 'United States, Ohio',
  'us-west-1': 'United States, North California',
  'us-west-2': 'United States, Oregon',
})
